<div class="title">{{options?.title?.text}}</div>
<!-- Now the single.value.chart has two kinds of loaders: either via loaderMessage/text or isLoading - graphic loader -->
<div class="loader-message-wrapper" *ngIf="loading && loaderMessage">
  <div>
    {{loaderMessage}}
  </div>
</div>
<loader-spinner *ngIf="loading && isLoading"></loader-spinner>
<div *ngIf="!loading" [ngClass]="classes" class="chart-container" [attr.id]="id"
     (mousemove)="onMouseMove(chart, $event)"
     (mouseleave)="onMouseLeave()"></div>

